import React from 'react';
import { darkenHexColor } from 'app/BargainWidget/Bargains/utils/common-utils';
import { useBargain } from 'app/BargainWidget/context/BargainContext';

const OfferAcceptedV1 = () => {
  const { translation, widgetSettings, acceptedOfferData } = useBargain();

  return (
    <div className="se-text-center se-py-6 se-px-4 bargain-widget-v1-auth">
      <h3 className="se-text-base se-text-gray-900 se-mb-2 bargain-widget-v1-offer-accepted-label">{acceptedOfferData?.message}</h3>
      {acceptedOfferData?.invoiceUrl && (
        <div className="se-mt-6 se-w-full bargain-widget-v1-offer-accepted-actions">
          <button
            onClick={() => window.open(acceptedOfferData?.invoiceUrl, "_blank", "noopener noreferrer")}
            style={
              {
                '--offer-button-background-color': widgetSettings?.offerButtonBackgroundColor || '#000000',
                '--offer-button-hover-background-color': darkenHexColor(widgetSettings?.offerButtonBackgroundColor || '#000000', 3),
                '--offer-button-text-color': widgetSettings?.offerButtonTextColor || '#ffffff',
              } as any
            }
            className="se-w-full se-px-6 se-py-2 se-rounded-md se-bg-[var(--offer-button-background-color)] hover:se-bg-[var(--offer-button-hover-background-color)] se-text-[var(--offer-button-text-color)] se-font-medium se-transition-colors bargain-widget-v1-offer-accepted-checkout-button"
          >
            {translation?.historyCheckout || "Checkout"}
          </button>
        </div>
      )}
    </div>
  );
};

export default OfferAcceptedV1;
